<template>
	<div class="home-banner-item" :style="`background-image: url(${banner.urlImage})`">
		<div class="home-banner-item-background">
			<a
				:href="banner.link"
				class="home-banner-item-btn href-depressed"
				target="_blank"
			>
				{{ banner.btn }}
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'home-banner-item',
		props: {
			banner: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.home-banner-item {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 100%;
		width: 100%;

		&-background {
			background-color: rgba(0, 0, 0, 0.5);
			height: 100%;
			position: relative;
			width: 100%;
		}

		&-btn {
			bottom: 200px;
			border: 1px solid color(white);
			border-radius: 6px;
			color: color(white);
			font-size: size(medium17);
			font-weight: weight(medium);
			left: 0px;
			margin: 0 auto;
			padding: 11px 17px;
			position: absolute;
			right: 0px;
			width: fit-content;
			width: -moz-fit-content;
			z-index: 1;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/home-store/home-banner-item.vue